/** 씨앗값이 같으면 같은 순서를 내는 난수.
 *
 * 사다리·병 돌리기처럼 "결과가 참여자 모두에게 같아야 하는" 화면에서 씁니다.
 * Math.random 을 쓰면 기기마다 다른 그림이 나오므로 쓰지 않습니다.
 * (선형 합동 생성기 — 그래픽 배치용이라 암호학적 용도로는 쓰지 마세요)
 */
export function seededRandom(seed: number): () => number {
    let s = seed >>> 0;
    return () => {
        s = (s * 1664525 + 1013904223) >>> 0;
        return s / 0xffffffff;
    };
}
